define('modules/list/list_view',[
  'backbone',
  'jquery',
  '_',
  './list_model',
  './list_item_collection',
  'text!./list_item_template.html',
], function (Backbone, $, _, ListModel, ListItemCollection, item_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      if (this.collection) {
        this.collection = new ListItemCollection(this.items);
      }

      this.listenTo(
        this.collection,
        'add',
        function (model) {
          this.renderSingleItem(model);
        },
        this
      );

      this.render();
    },

    collection: ListItemCollection,
    model: new ListModel(),
    subViews: [],
    item_template: _.template(item_template),
    tagName: 'ul',
    className: 'list',

    events: {
      'click .js-delete-item': 'deleteItem',
    },

    render: function () {
      var items = [];
      this.collection.each(function (item) {
        item.set('index', this.collection.indexOf(item));
        items.push(this.item_template(item.toJSON()));
      }, this);
      this.$el.html(items);
      return this;
    },

    renderSingleItem: function (item) {
      this.$el.append(this.item_template(item.toJSON()));
    },

    deleteItem: function (e) {
      var listItem = $(e.currentTarget).closest('.list-item'),
        index = parseInt(listItem.data('index'), 10),
        item = this.collection.at(index);
      e.preventDefault();

      var t = setTimeout(function () {
        item.get('model').set('confirm-removal', false);
        $(e.currentTarget).removeClass('confirm');
      }, 3000);

      if (item.get('model').get('confirm-removal')) {
        clearTimeout(t);
        item.get('model').destroy({
          dataType: 'text',
          success: function () {
            listItem.fadeOut(200);
          },
        });
      } else {
        item.get('model').set('confirm-removal', true);
        $(e.currentTarget).addClass('confirm');
      }
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },
  });
  return View;
});

